<template>
    <v-dialog 
        v-model="showRole"
        v-if="showRole"
        persistent
        @click:outside="closeModal"
    >
        <div class="topic-wrapper">
            <div class="topic-header">
                <span class="topic-name">
                    {{ topic.name }}
                </span>
                <div class="topic-actions">
                    <span
                        v-if="checkAuthorization('setting-role_create')"
                        class="topic-action"
                        @click="createNewRole()"
                    >
                        Thêm nhóm quyền
                    </span>
                    <span
                        v-if="checkAuthorization('setting-role_update')
                          && checkAuthorization('setting-role_create')"
                    > | </span>
                    <span
                        v-if="checkAuthorization('setting-role_update')"
                        class="topic-action"
                        @click="showModalDetail()"
                    >
                        Sửa
                    </span>
                    <span
                        v-if="checkAuthorization('setting-role_update')
                          && checkAuthorization('setting-role_delete')"
                    > | </span>
                    <span
                        v-if="checkAuthorization('setting-role_delete')"
                        class="topic-action"
                        @click="deleteTopic()"
                    >
                        Xóa
                    </span>
                </div>
            </div>
            <div class="topic-roles">
                <div class="role-data" v-for="(role, indexRole) in topic.roles" :key="indexRole">
                    <v-icon>mdi-account-outline</v-icon>
                    <div class="role-name">
                        {{ role.name }}
                    </div>
                    <div class="role-actions">
                        <span
                            v-if="checkAuthorization('setting-role_update')"
                            class="role-action"
                            @click="detailRole(role)"
                        >
                            Sửa
                        </span>
                        <span
                            v-if="checkAuthorization('setting-role_update')
                              && checkAuthorization('setting-role_delete')"
                        > | </span>
                        <span
                            v-if="checkAuthorization('setting-role_delete')"
                            class="role-action"
                            @click="deleteRole(role)"
                        >
                            Xóa
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    props: {
        showRole: {
            type: Boolean,
            default: false
        },
        topic: {
            type: Object,
            default: () => {}
        }
    },

    methods: {
        closeModal() {
            Bus.$emit('close-topic-role-modal')
        },

        showModalDetail() {
            Bus.$emit('show-detail-topic-modal', this.topic)
            Bus.$emit('close-topic-role-modal')
        },

        deleteTopic() {
            Bus.$emit('delete-topic', this.topic)
            Bus.$emit('close-topic-role-modal')
        },

        createNewRole() {
            this.$router.push({
                path: '/setting/create-role',
                query: {
                    topicId: this.topic.id
                }
            })
        },

        detailRole(role) {
            this.$router.push({
                name: 'EditRole',
                params: {
                    id: role.id
                }
            })
        },

        deleteRole(role) {
            Bus.$emit('delete-topic-role', role)
            Bus.$emit('close-topic-role-modal')
        }
    }
}
</script>

<style scoped>
/deep/.v-dialog {
    max-width: 800px;
    overflow: hidden;
}

.topic-wrapper {
    background-color: white;
    border: 1px inner black;
    border-radius: 15px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.topic-header {
    width: 100%;
    padding: 15px 20px 15px 30px;
    background-color: #F3F2F9;
    border-radius: 15px 15px 0px 0px;
}

.topic-name {
    font-size: 20px;
    font-weight: 600;
}

.topic-actions {
    display: none;
    font-size: 14px;
    color: #2D9CDB;
    float: right;
    padding-top: 4px;
}

.topic-action {
    cursor: pointer;
}

.topic-action:hover {
    text-decoration: underline;
    text-underline-position: below;
}

.topic-wrapper:hover .topic-actions {
    display: block;
}

.topic-roles {
    padding: 15px 20px 15px 30px;
    overflow: auto;
    max-height: 80vh;
}

.role-data {
    display: flex;
    padding: 10px 0px;
}

.role-data i {
    font-size: 24px;
}

.role-name {
    font-size: 16px;
    padding: 4px 0px 0px 10px;
}

.role-data:hover .role-name {
    font-weight: 600;
}

.role-actions {
    display: none;
    font-size: 14px;
    color: #2D9CDB;
    padding: 6px 0px 0px 10px;
}

.role-action {
    cursor: pointer;
}

.role-action:hover {
    text-decoration: underline;
    text-underline-position: below;
}

.role-data:hover .role-actions {
    display: block;
}
</style>